import { gql } from '@apollo/client'

export const MARK_NOTIFICATION_READ_MUTATION = gql`
  mutation markNotificationRead($id: ID!) {
    markNotificationRead(id: $id) {
      notification {
        id
        read
        readAt
      }
      errors
    }
  }
`
